import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

import { EnumUserRole } from 'lib/graphql';
import { BaseModule } from 'lib/modules';

// Lazy-loaded page components
const ProcessorCapabilitiesTab = lazy(() =>
  import(
    /* webpackChunkName: "processor-capabilities" */ 'pages/processor/capabilities'
  ).then((m) => ({ default: m.ProcessorCapabilitiesTab })),
);

const ProcessorCutsheets = lazy(() =>
  import(
    /* webpackChunkName: "processor-cutsheets" */ 'pages/processor/cutsheets'
  ).then((m) => ({ default: m.default })),
);

/**
 * Capabilities V1 Module Implementation (Legacy)
 */
class CapabilitiesV1ModuleClass extends BaseModule {
  id = 'CAPABILITIES_V1';
  name = 'Capabilities V1';
  label = 'Cut Capabilities (Legacy)';
  description = 'Legacy cutsheet capabilities and cutsheet management';
  version = '1.0.0';
  /**
   * Creates route objects for the Capabilities V1 module
   * @param ProtectedRoute
   * @param LazyWrapper
   * @param settings
   * @param ModuleProtectedRoute
   */
  createRoutes = (
    ProtectedRoute: any,
    LazyWrapper: any,
    settings?: any,
    ModuleProtectedRoute?: any,
  ): RouteObject[] => {
    const routes: RouteObject[] = [];
    const RouteProtector = ModuleProtectedRoute || ProtectedRoute;

    // Capabilities management
    routes.push({
      path: '/processor/capabilities',
      element: (
        <RouteProtector
          component={ProcessorCapabilitiesTab}
          moduleId="CAPABILITIES_V1"
          allowedUserRoles={[EnumUserRole.Vendor]}
        />
      ),
    });

    // Cutsheets management
    routes.push({
      path: '/processor/cutsheets',
      element: (
        <RouteProtector
          component={ProcessorCutsheets}
          moduleId="CAPABILITIES_V1"
          allowedUserRoles={[EnumUserRole.Vendor]}
        />
      ),
    });

    return routes;
  };
}

// Export singleton instance
export const CapabilitiesV1Module = new CapabilitiesV1ModuleClass();
